"use strict";

module.exports = function (element, message) {
    var errorHtml = "<div class=\"alert c-error-message alert-danger alert-dismissible " +
    "fade show\" role=\"alert\">" +
    "<div class=\"float-left p-2\" data-dismiss=\"alert\" aria-label=\"Close\">" + "<svg class=\"svg-inline icon-close-light icon-close-light-red\" role=\"img\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" width=\"16\" height=\"16\"><path d=\"M1.01-.01l15 15m-15 0l15-15M1.722-.112l15 15m-15 0l15-15\" fill=\"none\" stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/><path d=\"M1.01.89l14.102 14.1m-14.102 0L15.112.89\" fill=\"none\" stroke=\"#ca2f2f\" stroke-width=\"1.88\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/></svg>"+
    "</div>" + message + "</div>";

    $(element).html(errorHtml);
};
